import { defaultHttps } from "utils/url";

export const squarespaceAdminUrl = (domain) => `${defaultHttps(domain)}/config`;

export const squarespaceProductAdminUrl = (domain) =>
  `${defaultHttps(domain)}/config/commerce/inventory`;
